module.exports = __webpack_public_path__ + "static/media/pilot01.b1334c59.jpg";